
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersDayColour as ObiLightningRainShowersDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-day-colour.js';
 
 
 

 
 export const ObiLightningRainShowersDayColour = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-day-colour',
   elementClass: ObiLightningRainShowersDayColourElement,
   events: {
     
   }
  });
 
 